export const Graphic = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 100 100"
      width="100"
      height="100"
    >
      <g clipPath="url(#a)">
        <path
          fill="#F5F5F5"
          d="M49.4 93.1c27.3 0 49.4-12 49.4-27 0-14.9-22.1-27-49.4-27C22.1 39.1 0 51.2 0 66.1c0 15 22.1 27 49.4 27Z"
        />
        <path
          fill="#E6E6E6"
          d="M77.6 76.3c6.6 0 11.9-3 11.9-6.8s-5.3-6.8-11.9-6.8c-6.5 0-11.8 3-11.8 6.8s5.3 6.8 11.8 6.8Zm-58 .7c6.5 0 11.8-3 11.8-6.8 0-3.7-5.3-6.8-11.8-6.8-6.6 0-11.9 3-11.9 6.8s5.3 6.9 11.9 6.9Z"
        />
        <path fill="#F9B18B" d="m83.5 68-2.1-.1-.5-4.2 2.5.7v3.7Z" />
        <path
          fill="#263238"
          d="M79 71.5a.6.6 0 0 0 0 .5c.2.3.8.6 1.6.6.7 0 1.4 0 1.8-.3a1.3 1.3 0 0 0 .7-1c0-.4 0-.9.2-1.2.2-.3.5-.6.5-.8v-.9L79 71.5Z"
        />
        <path
          fill="#455A64"
          d="m81 67.8-.1.5a4.3 4.3 0 0 1-.8 1.3l-.7.8c-.3.2-.4.5-.5.9 0 .6 1 .8 1.4.9L82 72a1.5 1.5 0 0 0 1-1.2l.1-.5c0-.3.2-.7.5-1l.3-.6c.2-.3 0-.7 0-1-.1-.4-.2-.8-.3-.7 0 .1 0 .2-.2.3l-.3.4.1-.4v-.1l-.2-.1a3.7 3.7 0 0 0-1.7-.2l-.1.1-.1.2v.5Z"
        />
        <path
          fill="#F5F5F5"
          d="M80.4 69.3c.2-.2 1-.2 1.2-.1.3 0 .6 0 .8.2a.2.2 0 0 0 .2 0 .2.2 0 0 0 0-.2c-.3-.2-.5-.3-.9-.3h-1.1s-.3.2-.2.4Zm-.5.7c.2-.2 1-.2 1.3-.2.3 0 .6.1.8.3a.2.2 0 0 0 .2 0 .2.2 0 0 0 0-.3l-1.2-.3h-.8a.6.6 0 0 0-.3.4Zm2.1-1.8-1.1.1c-.1 0-.2.2-.1.3l1-.1a2.2 2.2 0 0 1 .9.3.2.2 0 0 0 .2 0 .1.1 0 0 0 0-.3l-.9-.3Z"
        />
        <path fill="#F9B18B" d="m75.7 66.2-2-.6v-4l2.5.2-.5 4.4Z" />
        <path
          fill="#263238"
          d="M69.6 68.3v.5c.1.2 1 .6 2 .6.8 0 1.6-.4 2.2-.8.4-.3.9-.3 1.4-.4.5 0 1.2-.3 1.3-.5V67l-6.9 1.3Z"
        />
        <path
          fill="#455A64"
          d="M74 65h-.4l-.3.5c-.2.3-.7.6-1.2 1l-1 .4c-.4.2-1 .3-1.2.5-.4.3-.5 1 0 1.3.4.2 1.5.5 2.6.1.7-.1 1.4-.8 2.2-.9.5 0 1.5-.1 1.8-.5.1-.2 0-.8-.2-1.3-.1-.5-.2-1.3-.4-1.2a.2.2 0 0 1-.1.1l-.2.2c-.2.1-.3.3-.3.4l-.2.2h-.5v-.5L74 65Z"
        />
        <path
          fill="#F5F5F5"
          d="M72.6 66.1a.5.5 0 0 1 .4-.2l.9.3a.2.2 0 0 1-.1.4h-.2c-.2-.3-.6-.5-1-.5Zm-.7.4a.6.6 0 0 1 .4-.2c.4 0 .7.2 1 .4a.2.2 0 0 1 0 .2.2.2 0 0 1-.2 0 1.5 1.5 0 0 0-1.2-.4Zm-.9.5a.6.6 0 0 1 .5-.3c.4 0 .7.2 1 .4a.2.2 0 0 1 0 .2.2.2 0 0 1-.1.1h-.2a1.4 1.4 0 0 0-1.1-.5Z"
        />
        <path
          fill="#455A64"
          d="M83 40.2a591.2 591.2 0 0 1 .3 16.3l.2 9.2s-1.3.6-2.5.1L79 54l-.8-7.7-.8 6.9v3.3L76 64a4 4 0 0 1-2.4-.1V53l.3-15 9.1 2.1Z"
        />
        <path
          fill="#37474F"
          d="M78.2 46.2 78 44c-1-.2-1.8-.7-2.6-1.2 0 0 .5.7 2.2 1.5l.4 2.1-.4 6.8.7-6.9Z"
        />
        <path
          fill="#F9B18B"
          d="m73.8 28.7-3.7 5-2.9-2.2c-.6-.5-.8-1.2-1.2-1.7-.5-.5-1-.6-1.4-1-.5-.4-.6-.7-.8-.3-.2.3.4 1 .5 1 0 .2.6.5-.1.5s-2.1-.9-2.4-1c-.4-.1-.4.3-.2.5.1.3 0 1 .3 1.5.1.5.5.8 1.1 1.1.6.3 2 .5 2.6.8l3.5 3.5c.7.5 1.4 1 2.4 0s4.2-5 4.2-5l.6-3.9c-1 0-1.8.2-2.5 1.2Z"
        />
        <path
          fill="#9E6767"
          d="M70.1 33.7c.4.3.8 1 .8 1.2a2 2 0 0 0-.6-1.4l-.2.2Z"
        />
        <path
          fill="#37474F"
          d="M76.5 27.4s-1.4 0-2 .5a10 10 0 0 0-2.3 2.6l-1.3 2a5 5 0 0 0 2.5 1.9L76 31l.4-3.6Z"
        />
        <path
          fill="#41B872"
          d="m79.4 27.4 2.8.1c.6.3 1.7 1.2 1.6 2l-1 6.7.3 4.4c-1.2 1.2-6.5 1.6-9.3-.2 0 0 0-8 .3-9.4.3-2.4.6-3.3 1.9-3.5 1.2-.2 3.4-.1 3.4-.1Z"
        />
        <path
          fill="#F9B18B"
          d="M84 28.8c.7.7 3.8 5 3.8 5l2.8-2.2c.7-.6.9-1.2 1.3-1.7s.9-.6 1.4-1c.4-.4.6-.7.8-.4.1.4-.4 1-.5 1.1 0 .2-.6.5.1.5s2-.9 2.4-1c.3-.2.3.2.2.5-.2.3 0 1-.3 1.5-.2.5-.5.7-1.1 1-.6.4-2.1.6-2.6.9l-3.5 3.4c-.7.5-1.4 1-2.5 0-1-1-3.4-4.2-3.4-4.2l-1.3-4.6c1 0 1.8.2 2.5 1.2Z"
        />
        <path
          fill="#9E6767"
          d="M87.8 33.8c-.4.3-.8 1-.9 1.2a2 2 0 0 1 .7-1.5l.2.3Z"
        />
        <path
          fill="#37474F"
          d="M81.4 27.5s1.4-.1 2 .4c.7.5 1.2 1.1 2.2 2.7l1.4 2a5 5 0 0 1-2.5 1.8l-1.9-2.3c-1-1.2-2-3-1.2-4.6Z"
        />
        <path
          fill="#263238"
          d="M79.6 21.3a2.6 2.6 0 1 1-5.2 0 2.6 2.6 0 0 1 5.2 0Zm1.9 1.9s-.4 2-.6 2.2l-.5.5v-1.4l1-1.3Zm-.5-2.8a1 1 0 0 1 .7.2c.4.4.2 1.5-.2 2.6h-.8l.2-2.8Z"
        />
        <path
          fill="#F9B18B"
          d="m80.5 23.3.5-.5c.2-.2.9-.4 1.2.2.3.7-.3 1.6-.8 1.8-.8.2-1-.3-1-.3v3.2c-1 1.4-4 1.3-2.8-.2v-1c-.4.2-.8.2-1.2.2-.6-.1-1-.6-1.2-1.3-.3-1.1-.5-2-.2-4.2.2-2.3 3-2.4 4.5-1.5 1.5 1 1 3.6 1 3.6Z"
        />
        <path
          fill="#263238"
          d="m80.5 23.5.5-.7c.3-.2 0-2.4 0-2.4a1 1 0 0 0-.3-1.3c-.3-.4-.9-.9-2.6-.7-1.2.2-2.5.6-3.5 0a1.8 1.8 0 0 0 .6 2l1.4.4 2.8-.1c.3 0 .4.2.5 1 .2.7.3 1.8.6 1.8Z"
        />
        <path
          fill="#263238"
          d="m81 20.5.9-.5a.5.5 0 0 0-.7-.2.6.6 0 0 0-.3.7Z"
        />
        <path
          fill="#9E6767"
          d="M77.6 26.6s1.4-.3 1.9-.6c.3-.1.5-.4.7-.7l-.4.8c-.4.5-2.2.9-2.2.9v-.4Z"
        />
        <path
          fill="#C8C8C8"
          d="M84.2 7c.4 0 .8.2 1.2.4l1 .8.5 1v1.3a2.5 2.5 0 0 1-1 1.5l-.7.5-.7.3-.6.4-.4.5-.1.3a.3.3 0 0 1-.3 0l-1-.2a.4.4 0 0 1-.3-.2.3.3 0 0 1 0-.3c0-.3.2-.6.4-.8l.7-.7.7-.4a20 20 0 0 0 1.3-.8l.2-.4a1 1 0 0 0-.2-1 2 2 0 0 0-1-.6c-.9-.2-1.5.1-2 .8l-.3.2a.3.3 0 0 1-.2 0l-1.1-.2a.3.3 0 0 1-.2-.2.3.3 0 0 1 0-.2c0-.3.2-.7.4-1l1-.7a4.1 4.1 0 0 1 2.7-.3ZM83 14.9a.4.4 0 0 1 .2.1.4.4 0 0 1 0 .3l-.2 1.2a.4.4 0 0 1-.4.3l-1.2-.3a.4.4 0 0 1-.3-.1.4.4 0 0 1 0-.3l.3-1.2a.4.4 0 0 1 .4-.3l1.2.3Zm4.7 3.4h.8c.3 0 .6 0 .9.2l.6.5c.2.3.3.5.3.8a1.7 1.7 0 0 1-.2 1.3l-.3.4-.4.5-.3.4-.1.4v.2a.2.2 0 0 1-.2.1l-.7.1a.3.3 0 0 1-.3-.1v-.8c0-.2.2-.4.3-.5 0-.2.2-.4.3-.5a15.9 15.9 0 0 0 .6-.8l.1-.4a.7.7 0 0 0-.4-.6h-.9a1.3 1.3 0 0 0-1 1v.1l-.3.1-.7.1h-.2a.2.2 0 0 1 0-.1c-.1-.3 0-.5 0-.8l.4-.7a2.8 2.8 0 0 1 1.7-.9Zm1.2 5.4a.3.3 0 0 1 .3.1l.2 1a.3.3 0 0 1 0 .1.2.2 0 0 1-.3.1l-.8.2a.3.3 0 0 1-.2 0 .2.2 0 0 1 0-.2l-.2-.9a.3.3 0 0 1 .2-.3l.8-.1Z"
        />
        <path
          fill="#000"
          d="M87.7 18.3h.8c.3 0 .6 0 .9.2l.6.5c.2.3.3.5.3.8a1.7 1.7 0 0 1-.2 1.3l-.3.4-.4.5-.3.4-.1.4v.2a.2.2 0 0 1-.2.1l-.7.1a.3.3 0 0 1-.3-.1v-.8c0-.2.2-.4.3-.5 0-.2.2-.4.3-.5a16 16 0 0 0 .6-.8l.1-.4a.7.7 0 0 0-.4-.6h-.9a1.3 1.3 0 0 0-1 1v.1l-.3.1-.7.1h-.2a.2.2 0 0 1 0-.1c-.1-.3 0-.5 0-.8l.4-.7a2.8 2.8 0 0 1 1.7-.9Zm1.2 5.4a.3.3 0 0 1 .2 0 .3.3 0 0 1 .1.2l.2.8a.3.3 0 0 1 0 .2.2.2 0 0 1-.3.1l-.8.2a.3.3 0 0 1-.2 0 .2.2 0 0 1 0-.2l-.2-.9a.3.3 0 0 1 .2-.3l.8-.1Z"
          opacity=".2"
        />
        <path
          fill="#C8C8C8"
          d="M95.2 20.7a.3.3 0 0 1 .1.4l-.6.8a.3.3 0 0 1-.4.1l-.8-.6a.3.3 0 0 1-.1-.2V21l.6-.8.2-.1h.2l.8.6Zm3.4-5.6.8.7.5 1v.9c0 .3 0 .7-.3 1a2 2 0 0 1-1.2.8 4 4 0 0 1-.7.1H97l-.5.2a1 1 0 0 0-.5.2l-.2.1a.3.3 0 0 1-.2 0l-.7-.5a.3.3 0 0 1-.2-.3l.1-.1.6-.6.7-.2.7-.1A17.5 17.5 0 0 0 98 18l.4-.3a.9.9 0 0 0 0-.8c0-.3-.3-.6-.6-.8-.5-.3-1-.4-1.7 0h-.2a.3.3 0 0 1-.2 0l-.8-.5v-.2a.2.2 0 0 1 0-.2l.6-.5 1-.3a3.4 3.4 0 0 1 2.1.6Z"
        />
        <path
          fill="#fff"
          d="M95.2 20.7a.3.3 0 0 1 .1.4l-.6.8a.3.3 0 0 1-.4.1l-.8-.6a.3.3 0 0 1-.1-.2V21l.6-.8.2-.1h.2l.8.6Zm3.4-5.6.8.7.5 1v.9c0 .3 0 .7-.3 1a2 2 0 0 1-1.2.8 4 4 0 0 1-.7.1H97l-.5.2a1 1 0 0 0-.5.2l-.2.1a.3.3 0 0 1-.2 0l-.7-.5a.3.3 0 0 1-.2-.3l.1-.1.6-.6.7-.2.7-.1A17.5 17.5 0 0 0 98 18l.4-.3a.9.9 0 0 0 0-.8c0-.3-.3-.6-.6-.8-.5-.3-1-.4-1.7 0h-.2a.3.3 0 0 1-.2 0l-.8-.5v-.2a.2.2 0 0 1 0-.2l.6-.5 1-.3a3.4 3.4 0 0 1 2.1.6Z"
          opacity=".6"
        />
        <path
          fill="#F9B18B"
          d="m23.6 64.7.4-7.2-3.1 2.3a50.5 50.5 0 0 1 .8 5.6c0 .8.8 1.2 1.5 1.7l1.8 1.2c.5.2 1.4.2 1.6 0L23.9 66c-.3-.4-.3-.6-.3-1.3Z"
        />
        <path
          fill="#263238"
          d="M28 69a.6.6 0 0 1-.2.6c-.6.5-1.3.6-2 .5-1-.1-1.6-.4-2-.7l-1.4-1c-.4 0-.7-.2-1-.4-.2-.1-.1-.7-.1-.7l6.6 1.7Z"
        />
        <path
          fill="#455A64"
          d="M21.7 65a.2.2 0 0 0-.2.2l-.1.9c-.1.5-.2 1-.1 1.4 0 .3.7.5 1.2.7.5.2 1 .5 1.4.9a4 4 0 0 0 2.1.8c.8 0 1.7-.3 1.9-.6.2-.5 0-.7-1.1-1.3l-1.3-.7c-.7-.4-1.4-1-1.7-1.9l-.2-.2h-.2a2 2 0 0 0-.5.2c-.2 0-.4.1-.4.3v.3a3 3 0 0 1-.4-.4l-.2-.2h-.2V65Z"
        />
        <path
          fill="#37474F"
          d="M23.9 69c-.2 0-.4-.2-.6-.4 0 0 1.3.9 1.9.5a.5.5 0 0 0 .2-.7s.8-.5 1.2-.5l.2.1c1.1.6 1.3.8 1 1.3-.1.3-.8.6-1.8.6a4 4 0 0 1-2.1-.8Z"
        />
        <path
          fill="#263238"
          d="M25.3 68.2c.7.3.4.4.2.4s-1.4-.6-2.2-1.2l-1.5-1.5-.3-.3v-.4a.2.2 0 0 1 .2-.1v.2l.2.1.2.2.3.4a9 9 0 0 0 2.9 2.2Z"
        />
        <path
          fill="#F5F5F5"
          d="M25.4 68.5v-.1a1.7 1.7 0 0 1 1.3-.5v.1a1.6 1.6 0 0 0-1.3.5Zm-.6-.4a1.7 1.7 0 0 1 1.3-.6v.2a1.6 1.6 0 0 0-1.3.4Zm-.6-.3v-.1a1.7 1.7 0 0 1 1.3-.6v.1a1.6 1.6 0 0 0-1.3.6Zm-.6-.4v-.1a1.7 1.7 0 0 1 1.3-.6v.1a1.6 1.6 0 0 0-1.3.5ZM23 67v-.2a1.7 1.7 0 0 1 1.4-.5v.1a1.6 1.6 0 0 0-1.3.5Z"
        />
        <path
          fill="#F9B18B"
          d="M17.6 60.5h-3.2c0 2 .4 4.4.4 6.4 0 .4 0 3 .2 3.8.2 1.1 1.6 1 1.7.3l-.1-4c0-1.3.6-3.5.9-5.8l.1-.7Z"
        />
        <path
          fill="#263238"
          d="M17.2 71.5c0 .5 0 1-.2 1.5a1 1 0 0 1-1.2.6c-.4-.1-1-.4-1.2-1-.2-.5-.3-1-.2-1.6l2.8.5Z"
        />
        <path
          fill="#455A64"
          d="m14.8 66.7-.1 1.9c0 1-.3 1.4-.3 2.2 0 1 0 1.4.4 1.9s1.6 1 2 0c.5-.6.4-1.3.3-2.2l-.3-2.4c0-.7 0-1.3-.2-1.4v.3l-.1.5v-.3l-.1-.2h-.2a5 5 0 0 0-.6 0H15a.2.2 0 0 0-.1 0v.4h-.1v-.7Z"
        />
        <path
          fill="#37474F"
          d="M14.4 70.6c0 .1 0 1 .2 1.1.3.2.4-.5.4-.5s.5-.3 1.5 0c0 .2.1.6.4.5.2-.1.2-1.1.2-1.2.1 1 .1 1.6-.2 2.3-.5.8-1.7.4-2.1-.1-.4-.5-.5-1-.4-1.9v-.2Z"
        />
        <path
          fill="#263238"
          d="M15 71.2c0 .3-.3.3-.3-.2v-2.4l.1-2v.8a39.8 39.8 0 0 1 .2 3.8Zm1.4 0V70a38.2 38.2 0 0 1 .2-3v-.3l.2.9v1c-.2.8 0 2 0 2.4-.1.5-.5.5-.4.2Z"
        />
        <path
          fill="#F5F5F5"
          d="M16.5 71.2a2.3 2.3 0 0 0-1.5 0h-.1a2.4 2.4 0 0 1 1.6 0Zm.1-.7a2.8 2.8 0 0 0-1.7 0v-.1c.5-.2 1.1-.2 1.7 0v.1Zm-1.7-.7v-.1a2.4 2.4 0 0 1 1.7 0s-1-.3-1.7 0v.1Zm0-.7h-.1a2.2 2.2 0 0 1 1.8 0 2.1 2.1 0 0 0-1.7 0Zm-.1-.7v-.1a2.3 2.3 0 0 1 1.8 0v.1s-1-.4-1.7 0Z"
        />
        <path
          fill="#455A64"
          d="M15.5 39.7c-1.2 3.1-1 5-.8 8.4l.5 5.6c0 .5-.8 1.6-1 4l.3 5s1.5.4 2.7 0c0 0 1.3-5.7 1.7-8.5l.8-5.5 1.1 5.5a8 8 0 0 0-.3 2.3c0 1.2.6 4.8.6 4.8s1.6.6 2.7-.4l.5-7a79 79 0 0 0-.7-13.6l-8.1-.6Z"
        />
        <path
          fill="#37474F"
          d="m19.7 48.7.5-4.1s2-.3 3-1.2a3.4 3.4 0 0 1-2.5 1.6l-.6 3.8.7 5.4-1-5.5Z"
        />
        <path
          fill="#F9B18B"
          d="M24.8 36.6c-1-1-2.8-3.3-2.8-3.3l-1-3.6h.7c1 0 1.4.2 2.1 1l3.4 4.3 1.9-2.4c.5-.7.4-1.5.6-2 .3-.6.7-.9 1-1.4.3-.5.4-.9.6-.6.3.3 0 1 0 1.1-.1.2-.5.7.2.4.6-.2 1.6-1.4 1.9-1.6.2-.3.4 0 .3.4 0 .3.2 1 .1 1.4 0 .5-.3 1-.7 1.3-.4.5-1.6 1-2 1.7-.5.6-1.4 2.5-2 3.7-.8 1.5-1.4 2-2.3 1.5-.8-.5-1.6-1.5-2-1.9Z"
        />
        <path
          fill="#EB4197"
          d="M21.3 29.7c.6-.1 1.1 0 1.7.2.6.2 1 .8 1.6 1.6l1.6 2.2s-.3 1.2-2.1 2.3L21 32.8l.3-3.1Z"
        />
        <path
          fill="#9E6767"
          d="M27.2 35c-.4.4-.6.8-.7 1.3 0 0-.3-.7.5-1.5l.2.2Z"
        />
        <path
          fill="#EB4197"
          d="M23.5 36c1.4-1.2 1-2.6.4-3.6-1-2-2-2.8-2.4-2.7h-2.8c-1.2.2-2.3 0-2.6.1-.8.2-.8.9-.8 1.7 0 1-.5.8-.3 2.4l.8 1.7c.1.6.5 1.4.3 2.3 0 .3-.3.6-.6 1.6-.4 1-.7 2-.9 3.1 0 0 .8-.2 1.7-1.1 0 0 1.2 1.6 4.2 1.5 3-.2 3.3-1.8 3.3-1.8l-.4-2.9.1-2.3Z"
        />
        <path
          fill="#000"
          d="M21.7 35.7s-1 .9-2.4.4a2.2 2.2 0 0 1-1.5-1.5s0 1.5 1.5 2a2.1 2.1 0 0 0 2.4-1Z"
          opacity=".1"
        />
        <path
          fill="#37474F"
          d="M14 28.4c-.4-.3-2.6 2.6-1.6 3.3 1 .7 2.1-1.3 1.9-2.3l-.3-1Z"
        />
        <path
          fill="#F9B18B"
          d="m12 27 1.4-2 .7-1 .5-.6c.3 0 .5-.2.6-.4.2-.1.2-.3.3-.4l1.1-1.2 1.4-.9c.3-.2.6-.5.3-.8a.8.8 0 0 0-.4-.2c-.8-.1-1.5.2-2.3.4l-1 .3-.4.3-.5.7c-.3.6-1 1.2-1.6 1.7l-1.8 1.7-1.8 1.8c-.4.5-.3.9-.2 1 .4.8.8 1 1.4 1.6a51.8 51.8 0 0 0 2.6 2.2l1.7 1.6c.4.4.8.8 1 1.3 1.2.2 2.4-1.6 1.4-3.7-.2-.3-.4-.6-.8-.8L12 26.9Z"
        />
        <path fill="#9E6767" d="M12 27a3 3 0 0 1-1.4 1s.7.1 1.7-.8l-.3-.3Z" />
        <path
          fill="#EB4197"
          d="M16.2 29.8 14 28.4s.2.4-.2 1.5c-.3 1-1 1.8-1.4 1.8 0 0 .8.6 1.4 1.3.7.6 1.3 1.1 1.7 1.9 0 0 1-.3 1.2-2 .1-1 0-2.5-.5-3Z"
        />
        <path
          fill="#263238"
          d="M23.7 24.5a2.7 2.7 0 0 0-.2-2.6 4.5 4.5 0 0 0-3.9-1.8h-.4c-2.2 0-4 1.9-4.1 4 0 1.4 0 2.7.8 3.7.7.9 1.8 1.2 2.8 1.3 1.8.3 4 .1 4.7-1.1 0 0-1 .2-1-1 0-.2 0-.4-.4-.6l.8-1c.3-.3.6-.5.9-1Z"
        />
        <path
          fill="#F9B18B"
          d="M23.1 25.5c0 2.2-.7 2.7-1 2.9h-1.7v1.2s.8.8.7 1.4c0 .6-1.1.7-2 .1l-1.3-1v-.4l-.1-3s-.4.4-1 0a1.2 1.2 0 0 1-.4-1.7.9.9 0 0 1 1.4.1c.1.4.1.6.4.6.3 0 .3-.3.3-.6v-.5c.7-.1 1.3-1 1.4-1.7.4.2.9.4 1.4.3.7 0 1-.1 1.4-.7l.2.4.2.9.1 1.7Z"
        />
        <path
          fill="#9E6767"
          d="M20.4 28.4c-.7-.1-2.1-.5-2.4-1l.5.7c.5.3 1.9.7 1.9.7v-.4Z"
        />
        <path
          fill="#C8C8C8"
          d="m13.8 7.4 1.3-.1 1.2.3c.3.2.7.4 1 .8.2.3.4.7.4 1v1c0 .4-.1.6-.3.9l-.5.7-.5.6a4 4 0 0 0-.4.6l-.1.6v.3a.3.3 0 0 1-.3.2l-1 .2a.4.4 0 0 1-.3 0 .3.3 0 0 1-.2-.3v-1l.4-.8.5-.7.5-.6.4-.6v-.6a1 1 0 0 0-.6-.8 2 2 0 0 0-1.2 0c-.8 0-1.3.6-1.5 1.4l-.1.3-.2.1-1.2.2H11a.3.3 0 0 1-.1-.2l.1-1c.1-.5.3-.8.6-1.1l1-1c.4-.2.8-.4 1.3-.4Zm2 7.7a.4.4 0 0 1 .5.3l.2 1.2a.4.4 0 0 1 0 .3.4.4 0 0 1-.3.1l-1.2.3a.4.4 0 0 1-.3 0 .4.4 0 0 1-.1-.3l-.3-1.2a.4.4 0 0 1 .1-.3.4.4 0 0 1 .2-.2l1.2-.2Zm9.2-2.7c.4.1.6.3.8.5l.5.7.2.8c0 .3-.1.6-.3.8a1.8 1.8 0 0 1-1 .9l-.5.1-.5.1-.5.2-.3.2-.2.1a.2.2 0 0 1-.2 0l-.6-.3a.3.3 0 0 1-.2-.3l.5-.6.6-.3.5-.1a15 15 0 0 0 1-.3l.3-.2a.7.7 0 0 0 0-.7c0-.3-.3-.5-.6-.6a1.3 1.3 0 0 0-1.4.1l-.2.1h-.2l-.7-.4V13a.2.2 0 0 1 0-.2c0-.2.3-.4.5-.5.2-.2.5-.3.8-.3h.9l.9.3Zm-2.3 5a.3.3 0 0 1 .2.1.3.3 0 0 1 0 .2l-.5.8a.3.3 0 0 1-.3 0l-.7-.3a.2.2 0 0 1-.2-.2.2.2 0 0 1 0-.2l.5-.7a.3.3 0 0 1 .1-.2.2.2 0 0 1 .2 0l.7.5Z"
        />
        <path
          fill="#000"
          d="M25 12.4c.4.1.6.3.8.5l.5.7.2.8c0 .3-.1.6-.3.8a1.8 1.8 0 0 1-1 .9l-.5.1-.5.1-.5.2-.3.2-.2.1a.2.2 0 0 1-.2 0l-.6-.3a.3.3 0 0 1-.2-.3l.5-.6.6-.3.5-.1a15 15 0 0 0 1-.3l.3-.2a.7.7 0 0 0 0-.7c0-.3-.3-.5-.6-.6a1.3 1.3 0 0 0-1.4.1l-.2.1h-.2l-.7-.4V13a.2.2 0 0 1 0-.2c0-.2.3-.4.5-.5.2-.2.5-.3.8-.3h.9l.9.3Zm-2.3 5a.3.3 0 0 1 .2.1.3.3 0 0 1 0 .2l-.5.8a.3.3 0 0 1-.3 0l-.7-.3a.2.2 0 0 1-.2-.2.2.2 0 0 1 0-.2l.5-.7a.3.3 0 0 1 .1-.2.2.2 0 0 1 .2 0l.7.5Z"
          opacity=".2"
        />
        <path
          fill="#C8C8C8"
          d="M9.4 20.5a.3.3 0 0 1 .3 0 .3.3 0 0 1 .2 0l.7.8a.3.3 0 0 1 0 .4l-.8.7a.3.3 0 0 1-.4 0l-.7-.8a.3.3 0 0 1 0-.4l.7-.7Zm-4.7-4.4.8-.7 1-.2h1l.8.6a2 2 0 0 1 .6 1.4v.7a57.3 57.3 0 0 0-.1 1.2l.1.5.1.2a.3.3 0 0 1 0 .3l-.7.5-.2.1a.3.3 0 0 1-.2 0 2 2 0 0 1-.4-.8l-.2-.7v-.7a17.1 17.1 0 0 0 .2-1.2l-.2-.4a.9.9 0 0 0-.8-.3c-.3 0-.6.2-.9.4-.5.5-.6 1-.4 1.7v.3a.3.3 0 0 1 0 .2l-.7.6h-.2a.2.2 0 0 1-.2 0l-.4-.8v-1c0-.3.1-.7.3-1 .1-.4.4-.7.7-1Z"
        />
        <path
          fill="#fff"
          d="M9.4 20.5a.3.3 0 0 1 .3 0 .3.3 0 0 1 .2 0l.7.8a.3.3 0 0 1 0 .4l-.8.7a.3.3 0 0 1-.4 0l-.7-.8a.3.3 0 0 1 0-.4l.7-.7Zm-4.7-4.4.8-.7 1-.2h1l.8.6a2 2 0 0 1 .6 1.4v.7a57.3 57.3 0 0 0-.1 1.2l.1.5.1.2a.3.3 0 0 1 0 .3l-.7.5-.2.1a.3.3 0 0 1-.2 0 2 2 0 0 1-.4-.8l-.2-.7v-.7a17.1 17.1 0 0 0 .2-1.2l-.2-.4a.9.9 0 0 0-.8-.3c-.3 0-.6.2-.9.4-.5.5-.6 1-.4 1.7v.3a.3.3 0 0 1 0 .2l-.7.6h-.2a.2.2 0 0 1-.2 0l-.4-.8v-1c0-.3.1-.7.3-1 .1-.4.4-.7.7-1Z"
          opacity=".6"
        />
        <path
          fill="#E6E6E6"
          d="M29.7 50c5.2-3 13.8-3 19 0 4.5 2.5 5.2 6.5 2.1 9.5.2 0 .3 0 .5.2l16.6 9.6c.8.4.8 1 0 1.5l-1 .6a2.6 2.6 0 0 1-2.5-.1L48.9 61.2l-.2-.2c-5.2 3-13.8 3-19 0-5.3-3-5.3-8 0-11Z"
        />
        <path
          fill="#0E97C2"
          d="M27.4 51.9v3.3c0 1.7 1.2 3.5 3.5 4.9A19 19 0 0 0 48 60c2.4-1.4 3.6-3.2 3.6-5v-3c0-1.8-1.2-3.6-3.6-5a18.9 18.9 0 0 0-17 0c-2.5 1.4-3.6 3.2-3.6 5Zm23 0c0 1.4-1 2.8-3 3.9-2.1 1.2-5 1.9-8 1.9s-5.8-.7-8-2c-1.8-1-2.9-2.4-2.9-3.8 0-1.5 1-2.9 3-4 2-1.2 5-1.8 8-1.8s5.8.6 8 1.8c1.8 1.1 2.9 2.5 2.9 4Z"
        />
        <path
          fill="#000"
          d="M39.8 58.8v3.3c-3.2 0-6.4-.6-9-2-2.3-1.4-3.5-3.2-3.5-5v-3.6c-.1 2 1 3.9 3.6 5.3 2.5 1.5 5.7 2.1 9 2Z"
          opacity=".1"
        />
        <path
          fill="#fff"
          d="M48 47a18.9 18.9 0 0 0-17 0c-4.8 2.7-4.8 7 0 9.8a18.9 18.9 0 0 0 17 0c4.7-2.7 4.7-7.1 0-9.9Zm-.6 8.8c-2 1.2-5 1.9-8 1.9s-5.8-.7-8-2c-1.8-1-2.9-2.4-2.9-3.8 0-1.5 1-2.9 3-4 2.1-1.2 5-1.8 8-1.8s5.8.6 8 1.8c1.8 1.1 2.9 2.5 2.9 4 0 1.4-1 2.8-3 3.9Z"
          opacity=".6"
        />
        <path
          fill="#0E97C2"
          d="M50.4 51.9c0 .5-.2 1.1-.5 1.6a7 7 0 0 0-2.5-2.3c-2-1.2-5-1.9-8-1.9s-5.8.7-8 2c-1 .5-1.8 1.2-2.4 2.2a3 3 0 0 1-.5-1.6c0-1.5 1-2.9 3-4 2.1-1.2 5-1.8 8-1.8s5.8.6 8 1.8c1.9 1.1 2.9 2.5 2.9 4Z"
        />
        <path
          fill="#fff"
          d="M47.4 49.4c-2-1.2-5-1.9-8-1.9s-5.8.7-7.9 2c-1.6.8-2.6 2-2.9 3 .3 1.2 1.3 2.4 3 3.3 2 1.2 4.8 1.8 7.9 1.8 3 0 5.8-.6 8-1.8 1.5-1 2.5-2 2.8-3.2-.3-1.2-1.3-2.3-2.9-3.2Z"
          opacity=".5"
        />
        <path
          fill="#37474F"
          d="M47.6 58.9a1.9 1.9 0 0 1 .9-1.5.6.6 0 0 1 .6 0l4 2.3a.6.6 0 0 1 .3.5 1.9 1.9 0 0 1-.8 1.5.6.6 0 0 1-.6 0l-4.1-2.3a.6.6 0 0 1-.3-.5Z"
        />
        <path
          fill="#263238"
          d="M47.9 59.4a.6.6 0 0 1-.3-.5l.2-.6 5.2 3-.4.4a.6.6 0 0 1-.6 0l-4.1-2.3Z"
        />
        <path fill="#000" d="m52.3 60.5-.1.2v-.2Z" />
        <path
          fill="#0E97C2"
          d="m66.3 68.6-14-8c.1-.4.4-.6.7-.8a.8.8 0 0 1 .7-.1l13.5 7.2-1 1.7Z"
        />
        <path
          fill="#fff"
          d="m66.3 68.6-14-8c.1-.4.4-.6.7-.8a.8.8 0 0 1 .7-.1l13.5 7.2-1 1.7Z"
          opacity=".6"
        />
        <path
          fill="#0E97C2"
          d="m66.3 68.6-1 1.9-13-8a.8.8 0 0 1-.4-.8V61l.1-.1.2-.3v-.2l14 8.1Z"
        />
        <path
          fill="#000"
          d="m66.3 68.6-1 1.9-13-8a.8.8 0 0 1-.4-.8V61l.1-.1.2-.3v-.2l14 8.1Z"
          opacity=".1"
        />
        <path
          fill="#0E97C2"
          d="M66.3 70.4a3.2 3.2 0 0 0 1.4-2.6c0-.9-.7-1.2-1.4-.8a3.2 3.2 0 0 0-1.5 2.5c0 1 .7 1.3 1.5.9Z"
        />
        <path
          fill="#000"
          d="M66.3 70.4a3.2 3.2 0 0 0 1.4-2.6c0-.9-.7-1.2-1.4-.8a3.2 3.2 0 0 0-1.5 2.5c0 1 .7 1.3 1.5.9Z"
          opacity=".3"
        />
      </g>
      <defs>
        <clipPath id="a">
          <rect width="100" height="100" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
};
